export enum RenderParamsSource {
  PERFORMANCE_TIER = 0,
  TESTING = 1,
  SCENE = 2,
}
